import React from "react";
// import FarmerIcon from "../../images/farmer.png";
import { Link, useNavigate } from "react-router-dom";
import { ethers } from "ethers";
import moment from "moment";

function UsersData({ transactionData }) {
  const navigate = useNavigate();
  return (
    <>
      {transactionData?.length > 0 &&
        transactionData?.map((data) => (
          <tr>
            <td className="p-2">
              <div className="flex items-center">
                <div className="d-block">
                  <div className="">
                    {moment.unix(data?.timeStamp).format("L")}
                  </div>
                  {/* <div className="text-sm text-gray-500">
                    {data?.gender} {data?.email}
                  </div> */}
                </div>
              </div>
            </td>
            <td className="p-2">
              <div className="d-block">
                <div >{data?.tokenName}</div>
                {/* <div className="text-sm text-gray-500">
                {data.department}
              </div> */}
              </div>
            </td>
            <td className="p-2">
              <div className="d-block overflow-hidden truncate w-40">
                <div >{data?.from}</div>
                {/* <div className="text-sm text-gray-500">
                {data.department}
              </div> */}
              </div>
            </td>

            <td className="p-2">
              <div className="d-block overflow-hidden truncate w-40">
                <div >{data?.to ? data?.to : "N/A"}</div>
                {/* <div className="text-sm text-gray-500">
                {data.department}
              </div> */}
              </div>
            </td>
            <td
              style={{
                width: "60px",
              }}
              className="p-2 truncate"
            >
              <div className="d-block overflow-hidden truncate w-40">
                <a
                  href={`https://mumbai.polygonscan.com/tx/${data?.hash}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-center truncate w-5 text-blue-500"
                >
                  {data?.hash ? data?.hash : "N/A"}
                </a>
                {/* <div className="text-sm text-gray-500">
                {data.department}
              </div> */}
              </div>
            </td>
            <td className="p-2">
              <div className="d-block">
                <div >
                  {data?.value ? ethers.utils.formatEther(data?.value) : "N/A"}
                </div>
                {/* <div className="text-sm text-gray-500">
                {data.department}
              </div> */}
              </div>
            </td>
            <td className="p-2">
              <div className="d-block">
                <div className="text-center uppercase">
                  {data?.from === "0x0000000000000000000000000000000000000000"
                    ? "Mint"
                    : data?.to === "0x0000000000000000000000000000000000000000"
                    ? "Burn"
                    : "Transfer"}
                </div>
                {/* <div className="text-sm text-gray-500">
                {data.department}
              </div> */}
              </div>
            </td>
          </tr>
        ))}
    </>
  );
}

export default UsersData;
